export default __webpack_public_path__ + "static/media/kunal.8fd11138.png";